import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChartCard = _resolveComponent("BarChartCard")!

  return (_openBlock(), _createBlock(_component_BarChartCard, {
    title: !_ctx.$vuetify.display.mobile ? _ctx.$t('shared.earnings') : _ctx.$t('shared.shortEarnings'),
    loading: _ctx.statsSalesMonthlyLoading,
    data: _ctx.statsSalesMonthlyData,
    activeBack: _ctx.activeBack,
    showYearNMinus1: true,
    yearNMinus1: _ctx.yearNMinus1,
    onOnYearNMinus1Changed: _cache[0] || (_cache[0] = 
            (value) => {
                _ctx.yearNMinus1 = value;
            }
        ),
    onOnSelectedTagsChanged: _cache[1] || (_cache[1] = 
            (value) => {
                _ctx.selectedTags = value;
            }
        ),
    md6: false,
    midHeight: true,
    onOnClosingVue: _cache[2] || (_cache[2] = 
            () => {
                _ctx.$emit('onClosingVue');
            }
        ),
    selectedTags: _ctx.selectedTags
  }, null, 8, ["title", "loading", "data", "activeBack", "yearNMinus1", "selectedTags"]))
}